  <div id="çeviriler">
  <p class="latin" lang="en">The crow has a piece of cheese in her beak.</p>
  <p class="yesil">
    — <a href="/cumle/goster/111"><img src="/kaynak/en.svg"></a>
  </p>

  <p class="latin" lang="az">Qarğanın dimdiyində bir parça pendir var.</p>
  <p class="yesil">
    — <a href="/cumle/goster/115"><img src="/kaynak/az.svg"></a>
  </p>



  <p class="arapca" lang="ar">الغراب لديه قطعة من الجبن في منقارها.</p>
  <p class="yesil">
    — <a href="/cumle/goster/116"><img src="/kaynak/ar.svg"></a>
  </p>



  <p class="latin" lang="tr">Karganın gagasında bir parça peynir vardır.</p>
  <p class="yesil">
    — <a href="/cumle/goster/123"><img src="/kaynak/tr.svg"></a>
  </p>


  </div>

